import jQuery from 'jquery';
import * as XLSX from 'xlsx';
export const ExportCSV = (fName, fileData) => {
    let data, filename, link;

    let csv = convertArrayOfObjectsToCSV(fileData);
    if (csv == null) return;

    filename = fName || 'export.csv';

    if (!csv.match(/^data:text\/csv/i)) {
        csv = 'data:text/csv;charset=utf-8,' + csv;
    }
    data = encodeURI(csv);

    link = document.createElement('a');
    link.setAttribute('href', data);
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
const convertArrayOfObjectsToCSV = (args) => {
    let result, ctr, keys, columnDelimiter, lineDelimiter, data;

    data = args || null;
    if (data == null || !data.length) {
        return null;
    }

    columnDelimiter = args.columnDelimiter || ',';
    lineDelimiter = args.lineDelimiter || '\n';
    keys = Object.keys(data[0]);
    result = '';
    result += keys.join(columnDelimiter);
    result += lineDelimiter;

    data.forEach(function (item) {
        ctr = 0;
        keys.forEach(function (key) {
            if (ctr > 0) result += columnDelimiter;

            result += item[key];
            ctr++;
        });
        result += lineDelimiter;
    });

    return result;
};
export const ImportCSV = (file, cb) => {
    const input = file[0];
    const reader = new FileReader();
    let data = []
    reader.readAsText(input)
    reader.onload = function (e) {
        const text = e.target.result;
        data = csvToArray(text)
        cb && cb(data)
    };
};
const csvToArray = (str, delimiter = ",") => {
    // slice from start of text to the first \n index
    // use split to create an array from string by delimiter
    const headers = str.slice(0, str.indexOf("\n")).split(delimiter);

    // slice from \n index + 1 to the end of the text
    // use split to create an array of each csv value row
    const rows = str.slice(str.indexOf("\n") + 1).split("\n");

    // Map the rows
    // split values from each row into an array
    // use headers.reduce to create an object
    // object properties derived from headers:values
    // the object passed as an element of the array
    const arr = rows.map(function (row) {
        const values = row.split(delimiter);
        const el = headers.reduce(function (object, header, index) {
            object[header] = values[index];
            return object;
        }, {});
        return el;
    });

    // return the array
    return arr;
}
export const ExportXLSX = (fName, fileData1, fileData2 = null) => {
    const workbook = XLSX.utils.book_new();
    const worksheet1 = XLSX.utils.json_to_sheet(fileData1);
    XLSX.utils.book_append_sheet(workbook, worksheet1, "Sheet1");
    if(fileData2) {
        const worksheet2 = XLSX.utils.json_to_sheet(fileData2);
        XLSX.utils.book_append_sheet(workbook, worksheet2, "Sheet2");
    }
    //let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
    //XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
    XLSX.writeFile(workbook, `${fName}.xlsx`);
}
export const ImportXLSX = (file, cb) => {
    let oFile = file[0];
    //let sFilename = oFile.name;
    let reader = new FileReader();
    reader.onload = (e) => {
        try {
            let data = e.target.result;
            // data = new Uint8Array(data);
            let workbook = XLSX.read(data, { type: 'binary' });
            workbook.SheetNames.forEach(sheet => {
                let rowObject = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheet]);
                cb && cb({IsSuccess:true, data:rowObject,msg:'Success'})
            });
        } catch (error) {
            cb && cb({IsSuccess:false, data:null,msg:'File Not Readable'})
        }
    };

    reader.readAsBinaryString(oFile);

}
export const PopUp = (id, flag) => {
    if (flag) {
        jQuery(".bg-page").addClass("modal-open")
        jQuery(`#${id}`).addClass("show")
        jQuery(`#${id}`).attr("style", "display:block")
        jQuery("#overLay").attr("style", "display:block")
        jQuery(".modal-backdrop").addClass("show")
    } else {
        jQuery(".bg-page").removeClass("modal-open")
        jQuery(`#${id}`).removeClass("show")
        jQuery(`#${id}`).attr("style", "display:none")
        jQuery("#overLay").attr("style", "display:none")
        jQuery(".modal-backdrop").removeClass("show")
    }
};

function xorEncryptDecrypt(input, key) {
    let result = [];
    for (let i = 0; i < input.length; i++) {
      result.push(input.charCodeAt(i) ^ key.charCodeAt(i % key.length));
    }
    return String.fromCharCode.apply(null, result);
  }
  export const Encrypt = (text) => {
    const encrypted = xorEncryptDecrypt(text, process.env.REACT_APP_ENCRYTDECRYPT_KEY);
    return btoa(encrypted) 
  }
  export const Decrypt = (text) => {
    const decoded = atob(text);
    return xorEncryptDecrypt(decoded, process.env.REACT_APP_ENCRYTDECRYPT_KEY);
  }